import 'css-chunksrc/client/scenes/addIdentityProvider/styles.scss';export default {
  "addIdentityProvider": "_addIdentityProvider_zxbos_1",
  "form": "_form_zxbos_7",
  "footer": "_footer_zxbos_13"
};